// ==================== 功能展示：材质切换 ====================
function updateBlocksByMaterial(selectedMaterial = null) {
  const materialSelector = document.querySelector(".product-form__input select");
  const material = selectedMaterial || materialSelector?.value || "";
  const normalizedMaterial = material.trim().toLowerCase();

  document.querySelectorAll(".custom-options-block").forEach((block) => {
    const blockMaterial = block.dataset.materialGroup?.toLowerCase();
    block.style.display =
      !blockMaterial || blockMaterial === "all"
        ? "block"
        : blockMaterial === normalizedMaterial
        ? "block"
        : "none";
  });
}

// ==================== 初始化多选模块（custom-option-block） ====================
function initCustomOptionBlocks() {
  document.querySelectorAll(".custom-options-block").forEach((block) => {
    const group = block.dataset.group;
    const input = block.querySelector(`#property-${group}`);
    const labelSpan = block.querySelector(`[data-selected-label-for="${group}"]`);

    block.querySelectorAll(".custom-option-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const selectedItems = Array.from(
          block.querySelectorAll(".custom-option-checkbox")
        )
          .filter((cb) => cb.checked)
          .map((cb) => cb.closest(".custom-option-item"));

        const titles = selectedItems.map((item) => item.dataset.title);
        const totalPrice = selectedItems.reduce(
          (sum, item) => sum + parseFloat(item.dataset.price || 0),
          0
        );

        if (input) input.value = titles.join(", ");
        if (labelSpan)
          labelSpan.innerText =
            totalPrice > 0
              ? `${titles.join(", ")} (+$${totalPrice})`
              : titles.join(", ") || "None";
      });
    });
  });
}

// ==================== 材质选择监听 ====================
function bindMaterialSelectWatcher() {
  const observer = new MutationObserver(() => {
    const materialSelect = document.querySelector(".product-form__input select");
    if (materialSelect && !materialSelect.dataset.bound) {
      materialSelect.addEventListener("change", () => {
        updateBlocksByMaterial(materialSelect.value);
        initCustomOptionBlocks();
      });
      materialSelect.dataset.bound = "true";
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// ==================== 工具：金额格式、DOM 解析、角标安全更新 ====================
function money(cents, currency) {
  const n = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || window?.Shopify?.currency?.active || "USD",
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}
function parseFirst(html, selector) {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.querySelector(selector);
}
function updateCartIconBubbleSafely(bubbleHTML) {
  if (!bubbleHTML) return;
  const incoming = parseFirst(bubbleHTML, "#cart-icon-bubble, .cart-icon-bubble");
  if (!incoming) return;
  document.querySelectorAll("#cart-icon-bubble, .cart-icon-bubble").forEach((node) => {
    node.innerHTML = incoming.innerHTML; // 只替换里面的内容，保留容器和事件
  });
}

// ==================== 初始化所有模块 ====================
function initCustomOptions() {
  updateBlocksByMaterial();
  initCustomOptionBlocks();
  bindMaterialSelectWatcher();

  document.addEventListener("variant:change", (e) => {
    const variant = e.detail?.variant;
    if (variant?.option1) {
      updateBlocksByMaterial(variant.option1);
      initCustomOptionBlocks();
    }
  });
}
document.addEventListener("DOMContentLoaded", initCustomOptions);
document.addEventListener("shopify:section:load", initCustomOptions);
document.addEventListener("shopify:section:select", initCustomOptions);
document.addEventListener("shopify:block:select", initCustomOptions);

// ==================== 加入购物车（系统 sections 回填 + Dawn 原生渲染） ====================
document.addEventListener("DOMContentLoaded", () => {
  const addButton = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!addButton) return;

  let submitting = false;

  addButton.addEventListener("click", async (event) => {
    const form =
      addButton.closest('form[action*="/cart/add"]') || addButton.closest("form");
    if (!form || submitting) return;

    event.preventDefault();
    submitting = true;

    const spinner = addButton.querySelector(".loading__spinner");
    spinner && spinner.classList.remove("hidden");
    addButton.disabled = true;

    try {
      // ====== ★★ ATC 前统一同步：让每个 Option Group 把隐藏字段刷新到表单 ★★ ======
      if (Array.isArray(window.OG_SYNC_REG)) {
        try { window.OG_SYNC_REG.forEach(fn => typeof fn === "function" && fn()); } catch(e) {}
      }
      // ===== 主商品：FormData + 全页兜底合并 properties =====
      const fd = new FormData(form);
      const mainId = fd.get("id");
      const quantity = Number(fd.get("quantity") || 1) || 1;

      const mainProperties = {};
      for (const [key, val] of fd.entries()) {
        const m = key.match(/^properties\[(.+?)\](\[\])?$/);
        if (!m) continue;
        const k = m[1];
        const isArr = !!m[2];
        if (isArr) {
          if (!Array.isArray(mainProperties[k])) mainProperties[k] = [];
          mainProperties[k].push(val);
        } else {
          mainProperties[k] = val;
        }
      }

      // 兜底收集（form 外的 properties）
      const extraInputs = Array.from(
        document.querySelectorAll('input[name^="properties["]')
      );
      const extraSelects = Array.from(
        document.querySelectorAll(
          'select[name^="properties["], textarea[name^="properties["]'
        )
      );
      function mergePropByName(name, value) {
        if (value == null) return;
        const trimmed = String(value).trim();
        if (trimmed === "") return;
        const m = name.match(/^properties\[(.+?)\](\[\])?$/);
        if (!m) return;
        const k = m[1];
        const isArr = !!m[2];
        if (isArr) {
          if (!Array.isArray(mainProperties[k])) mainProperties[k] = [];
          if (!mainProperties[k].includes(trimmed))
            mainProperties[k].push(trimmed);
        } else {
          mainProperties[k] = trimmed;
        }
      }
      extraInputs.forEach((inp) => {
        const type = (inp.getAttribute("type") || "").toLowerCase();
        if ((type === "radio" || type === "checkbox") && !inp.checked) return;
        mergePropByName(inp.name, inp.value);
      });
      extraSelects.forEach((el) => mergePropByName(el.name, el.value));

      // 多选数组 → 逗号拼接（Dawn 展示习惯）
      Object.keys(mainProperties).forEach((k) => {
        if (Array.isArray(mainProperties[k]))
          mainProperties[k] = mainProperties[k].join(", ");
      });

      const cartItems = [
        { id: parseInt(mainId, 10), quantity, properties: mainProperties },
      ];

      // ===== 附加商品（可选）：兼容旧模块的数据来源 =====
      const allowFreeAddons = false;
      function getLabelForInput(inp) {
        if (!inp.id) return null;
        return document.querySelector(`label[for="${inp.id}"]`);
      }
      const candidates = Array.from(
        document.querySelectorAll(
          'input[data-addon-handle][type="radio"]:checked, input[data-addon-handle][type="checkbox"]:checked, input[data-addon-handle][type="hidden"], input[type="radio"]:checked, input[type="checkbox"]:checked'
        )
      );
      const addonHandles = new Set();
      candidates.forEach((inp) => {
        let handle = (inp.dataset.addonHandle || "").trim();
        let price = parseFloat(inp.dataset.price || "NaN");
        const lab = getLabelForInput(inp);
        if (!handle && lab && lab.dataset.handle) handle = lab.dataset.handle.trim();
        if ((isNaN(price) || !isFinite(price)) && lab && lab.dataset.price)
          price = parseFloat(lab.dataset.price);
        if (!handle) return;
        if (allowFreeAddons || (isFinite(price) && price > 0)) addonHandles.add(handle);
      });
      for (const handle of addonHandles) {
        try {
          const res = await fetch(`/products/${handle}.js`, {
            credentials: "same-origin",
            cache: "no-store",
          });
          if (!res.ok) continue;
          const p = await res.json();
          const v = p.variants.find((x) => x.available) || p.variants[0];
          if (v?.id) {
            cartItems.push({
              id: v.id,
              quantity: 1,
              properties: { _group: "ADD-ON" },
            });
          }
        } catch (e) {
          console.warn("附加商品解析失败：", handle, e);
        }
      }

      // ===== 一次性提交（系统流派：让服务端返回最新 sections） =====
      const sectionsToUpdate = ["cart-drawer", "cart-icon-bubble"];
      const resp = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: cartItems,
          sections: sectionsToUpdate,
          sections_url: window.location.pathname,
        }),
        credentials: "same-origin",
        cache: "no-store",
      });

      if (!resp.ok) {
        const t = await resp.text();
        throw new Error(t || `status ${resp.status}`);
      }

      const data = await resp.json();

      // ===== 用 Dawn 原生方式渲染抽屉 & 角标 =====
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer && data.sections) {
        if (typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents({ sections: data.sections });
        } else {
          const html = data.sections["cart-drawer"] || "";
          const incomingInner = parseFirst(html, "#CartDrawer");
          const currentInner = cartDrawer.querySelector("#CartDrawer");
          if (incomingInner && currentInner) currentInner.replaceWith(incomingInner);
        }

        const hasRows = !!cartDrawer.querySelector("tbody tr");
        cartDrawer.classList.toggle("is-empty", !hasRows);
        cartDrawer.querySelector("#CartDrawer")?.classList.toggle("is-empty", !hasRows);
        const checkoutBtn = cartDrawer.querySelector("#CartDrawer-Checkout");
        if (checkoutBtn) {
          if (hasRows) checkoutBtn.removeAttribute("disabled");
          else checkoutBtn.setAttribute("disabled", "disabled");
        }

        if (data.sections["cart-icon-bubble"]) {
          updateCartIconBubbleSafely(data.sections["cart-icon-bubble"]);
        }

        if (typeof cartDrawer.open === "function") cartDrawer.open();
        else cartDrawer.setAttribute("open", "true");

        submitting = false;
        return;
      }

      // 没有抽屉就跳转购物车页
      submitting = false;
      window.location.href = "/cart";
    } catch (err) {
      console.error("加入购物车失败：", err);
      alert("加入购物车失败，请稍后再试。");
      submitting = false;
    } finally {
      spinner && spinner.classList.add("hidden");
      addButton.disabled = false;
    }
  });
});
